module.exports = __webpack_public_path__ + "img/TrasladoSeguro.a11decba.svg";